import React, { createContext, useContext } from 'react';
import themeConfig from './colors';

/**
 * Type definition for the theme context
 */
interface ThemeContextType {
  colors: typeof themeConfig.colors;
  opacity: typeof themeConfig.opacity;
  semantic: typeof themeConfig.semantic;
}

/**
 * Create the theme context with default values
 */
const ThemeContext = createContext<ThemeContextType>({
  colors: themeConfig.colors,
  opacity: themeConfig.opacity,
  semantic: themeConfig.semantic,
});

/**
 * Theme provider component to wrap the app
 */
export const ThemeProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  // For now, we're just using the light theme
  const theme = themeConfig;

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

/**
 * Custom hook to use the theme in components
 */
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default themeConfig; 